import { render } from "./UserAndImage.vue?vue&type=template&id=bba4e588&scoped=true"
import script from "./UserAndImage.vue?vue&type=script&lang=js"
export * from "./UserAndImage.vue?vue&type=script&lang=js"

import "./UserAndImage.vue?vue&type=style&index=0&id=bba4e588&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bba4e588"]])

export default __exports__